import { Theme } from '@components/AppBar/app-bar-state';
import { LIGHT_THEME_COLORS, DARK_THEME_COLORS } from '@constants';

export const getChartThemeColors = (theme: Theme) => {
  return theme === Theme.Dark ? DARK_THEME_COLORS : LIGHT_THEME_COLORS;
};
